import { ajax } from "../ajax";
import { ReqType as reqType } from "../config";
import { obj2formData } from "../../utils/objectUtils";
// 登陆注册相关
//登录API
export const loginApi = (params) => {
  // console.log('loginApi', params);
  return ajax("/voyage/login1", obj2formData(params), reqType.POST);
};

//检测email是否可用, p=email
export const checkEmailApi = (params) => {
  return ajax("/voyage/checkEmail", params);
};

//注册API
export const registerApi = (param) => {
  var form_data = new FormData();
  for (var key in param) {
    form_data.append(key, param[key]);
  }
  return ajax("/voyage/register", form_data, reqType.POST);
};
//退出登录API
export const logoutApi = () => {
  // console.log('logoutApi');
  return ajax("/voyage/logout");
};

//刷新用户信息
export const refreshTokenApi = () => {
  return ajax("/voyage/refreshToken");
};
